import React from 'react';
import PropTypes from 'prop-types';
import useQuiz from '../../store/useQuiz';

import { QuestionSection } from './styles';


const zodiacSigns = [
  { name: 'Aries', value: 'Aries' },
  { name: 'Taurus', value: 'Taurus' },
  { name: 'Gemini', value: 'Gemini' },
  { name: 'Cancer', value: 'Cancer' },
  { name: 'Leo', value: 'Leo' },
  { name: 'Virgo', value: 'Virgo' },
  { name: 'Libra', value: 'Libra' },
  { name: 'Scorpio', value: 'Scorpio' },
  { name: 'Sagittarius', value: 'Sagittarius' },
  { name: 'Capricorn', value: 'Capricorn' },
  { name: 'Aquarius', value: 'Aquarius' },
  { name: 'Pisces', value: 'Pisces' },
];

const QuizIntroComponent = ({ setIntroCompleted }) => {

  const [answers, setAnswers] = React.useState({
    firstname: null, lastname: null, sign: null,
  });

  const { setLocalStorage } = useQuiz();

  const handleChange = ({ target: { name, value } }) => {
    setAnswers(old => ({
      ...old,
      [name]: value,
    }));
  }

  React.useEffect(() => {
    const { firstname, lastname, sign, introCompleted, email } = answers;
    if (firstname && lastname && sign && email && !introCompleted) {
      handleChange({ target: { name: 'introCompleted', value: true } });
      setIntroCompleted(true);
    }
    setLocalStorage('open-love-user', answers);
  }, [answers]);

  React.useEffect(() => {
    const body = document.querySelector('body');
    const computedStyles = window.getComputedStyle(body);
    window.parent.postMessage({
      action: 'wordpress-iframe-height',
      height: computedStyles['height'],
    }, "*");
  }, [answers]);

  return (
    <React.Fragment>
      <QuestionSection>
        <label htmlFor="firstname">First Name:</label>
        <input name="firstname" type="text" onChange={handleChange} />
      </QuestionSection>
      <QuestionSection>
        <label htmlFor="lastname">Last Name:</label>
        <input name="lastname" type="text" onChange={handleChange} />
      </QuestionSection>
      <QuestionSection>
        <label htmlFor="sign">Sign:</label>
        <select name="sign" onChange={handleChange}>
            <option></option>
          {zodiacSigns.map(zodiac => (
            <option key={zodiac.name} value={zodiac.value}>{zodiac.name}</option>
          ))}
        </select>
      </QuestionSection>
      <QuestionSection>
        <label htmlFor="email">Email:</label>
        <input name="email" type="email" onChange={handleChange} />
      </QuestionSection>
    </React.Fragment>
  );
};

QuizIntroComponent.propTypes = {
  setIntroCompleted: PropTypes.func.isRequired,
}

export default QuizIntroComponent;
